
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Was haben eine Pizza im Santa Lucia am Bärenplatz, ein Businesslunch im Äusseren
Stand und ein Cocktail in der Kornhauskeller-Bar gemeinsam? Das Geld, welches
Berner ausgeben, fliesst nach Zürich. Wie Recherchen dieser Zeitung ergeben,
kommen die zwei grössten Beizer in Bern aus Zürich. Es sind der Zürcher
Frauenverein (ZFV) und Bindella. Nebst ihnen gibt es aber auch Berner
Unternehmer, die ein kleines Imperium aufgebaut haben: die SCB-Tochtergesellschaft Sportgastro, KG Gastrokultur, Taberna Gastro-Kultur, Burkhalter Gastro Management, Rajkumar Rochemuttu, Bonsoir und Two Spice.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;